/**
 * General utility functions.
 *
 * @constructor
 */
function GeneralUtility() {
}

function filterFunction(el) {
    var dropdown = el.closest('.dropdown-menu');
    var input = dropdown.querySelector('.dropdown-search');
    var filter = input.value.toUpperCase();
    var buttons = dropdown.querySelectorAll('button');
    var removeButton = dropdown.querySelector('.icon-remove');
    if (!input.dataset.widthset || input.dataset.widthset === "" || typeof input.dataset.widthset === 'undefined') {

        input.style.width = (dropdown.offsetWidth - 30) + 'px';
        input.dataset.widthset = "true";
    }

    //Remove no results message
    if (dropdown.querySelector('p')) {
        dropdown.querySelector('p').remove();
    }

    if (filter) {
        removeButton.classList.add('show');
        var foundResults = false;
        for (var i = 0; i < buttons.length; i++) {
            var txtValue = buttons[i].textContent || buttons[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                buttons[i].style.display = "";
                foundResults = true;
            } else {
                buttons[i].style.display = "none";
            }
        }

        if (!foundResults) {
            dropdown.insertAdjacentHTML('beforeend', '<p>' + input.dataset.noresults + '</p>');
        }
    } else {
        removeButton.classList.remove('show');
        for (var i = 0; i < buttons.length; i++) {
            buttons[i].style.display = "";
        }
    }

}

/**
 * Show loading animation of a single card / step in the wizard
 * @param card
 */
GeneralUtility.showLoadingAnimationOfCard = function (card) {
    if (card.querySelector('.card-header')) {
        card.querySelector('.card-header').classList.add('d-none');
    }
    if (card.querySelector('.collapse')) {
        card.querySelector('.collapse').classList.add('d-none');
    }
    if (card.querySelector('.loader')) {
        card.querySelector('.loader').classList.remove('d-none');
        card.querySelector('.loader').classList.add('d-flex');
    }
};

/**
 * Show loading animation of all date selection cards / steps in the wizard
 */
GeneralUtility.showLoadingAnimationOfAllDateSelectionCards = function () {
    var allDateSelectionCards = document.getElementById('modal-reservation-steps').querySelectorAll('.card[data-stepaction="date-selection"]');
    allDateSelectionCards.forEach(function (card) {
        GeneralUtility.showLoadingAnimationOfCard(card);
    });
};

/**
 * Hide loading animation of a single card / step in the wizard
 * @param card
 */
GeneralUtility.hideLoadingAnimationOfCard = function (card) {
    if (card.querySelector('.card-header')) {
        card.querySelector('.card-header').classList.remove('d-none');
    }
    if (card.querySelector('.collapse')) {
        card.querySelector('.collapse').classList.remove('d-none');
    }
    if (card.querySelector('.loader')) {
        card.querySelector('.loader').classList.add('d-none');
        card.querySelector('.loader').classList.remove('d-flex');
    }
};

/**
 * Hide loading animation of all date selection cards / steps in the wizard
 */
GeneralUtility.hideLoadingAnimationOfAllDateSelectionCards = function () {
    var allDateSelectionCards = document.getElementById('modal-reservation-steps').querySelectorAll('.card[data-stepaction="date-selection"]');
    allDateSelectionCards.forEach(function (card) {
        GeneralUtility.hideLoadingAnimationOfCard(card);
    });
};

/**
 * Converts a date string into a Date object
 *
 * @param {string} dateString date string
 * @return {Date} date object
 */
GeneralUtility.getDateObjectFromString = function (dateString) {
    if (dateString.indexOf('-') !== -1) {
        var parts = dateString.split('-');
        return new Date(parts[0], parts[1] - 1, parts[2]);
    } else if (dateString.indexOf('/') !== -1) {
        var parts = dateString.split('/');
        return new Date(parts[2], parts[0] - 1, parts[1]);
    } else {
        var parts = dateString.split('.');
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }
};

/**
 * Converts a date string into a Date object
 *
 * @param {Date} dateObject date object
 * @return {string} dateString
 */
GeneralUtility.getDateStringFromObject = function (dateObject) {
    var day = dateObject.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    var month = dateObject.getMonth() + 1;
    if (month < 10) {
        month = '0' + month;
    }
    var year = dateObject.getFullYear();

    if (parseInt(Globals.languageId) === 1) {
        return month + '/' + day + '/' + year;
    } else {
        return day + '.' + month + '.' + year;
    }
};

/**
 * Returns url with correct type parameter for given action
 *
 * @param {string} action
 * @return {string} url
 */
GeneralUtility.getAjaxUrl = function (action) {
    var typeNum = 0;
    switch (action) {
        case 'timeslots':
            typeNum = 6010;
            break;
        case 'wizard':
            typeNum = 6011;
            break;
        case 'user-info':
            typeNum = 6013;
            break;
        case 'notification-list':
            typeNum = 6014;
            break;
        case 'notification-read':
            typeNum = 6015;
            break;
        case 'wizard-save':
            typeNum = 6017;
            break;
        case 'show-code':
            typeNum = 6019;
            break;
        case 'cancel':
            typeNum = 6020;
            break;
        default:
    }

    if (!typeNum) {
        return '';
    }
    var url = '/?type=' + typeNum;
    if (parseInt(Globals.languageId) === 1) {
        url = '/en' + url;
    }

    //Add random part to URL to prevent browser caching
    url += '&rand=' + Math.random();
    return url;
}

/**
 *
 * Sends an AJAX get request and passes response text to callback function
 *
 * @param url
 * @param callback
 */
GeneralUtility.ajaxGetRequest = function (url, callback, errorCallback) {

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                if (callback && typeof callback === 'function') {
                    callback(xhr.responseText);
                }
            } else {
                if (errorCallback && typeof errorCallback === 'function') {
                    errorCallback(xhr.statusText);
                }
            }
        }
    };

    xhr.open('GET', url);
    xhr.send();
}

GeneralUtility.ajaxPostRequest = function (url, postData, contentType, callback, errorCallback) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-type', contentType);

    xhr.send(postData);

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                if (callback && typeof callback === 'function') {
                    callback(xhr.responseText);
                }
            } else {
                if (errorCallback && typeof errorCallback === 'function') {
                    errorCallback(xhr.statusText);
                }
            }
        }
    };
}

/**
 * Search dropdown items when user enters text in search field
 *
 * @returns {void}
 */
GeneralUtility.initializeDropdownSearch = function () {
    document.querySelectorAll('.dropdown').forEach(function (dropdown) {
        if (dropdown.dataset.searchinitialized !== 'true') {
            var searchInput = dropdown.querySelector('.dropdown-search');
            if (searchInput) {
                searchInput.addEventListener('keyup', function () {
                    filterFunction(this);
                });
                searchInput.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                });
            }
            var removeIcon = dropdown.querySelector('.dropdown-menu .icon-remove');
            if (removeIcon) {
                removeIcon.addEventListener('click', function (e) {
                    this.closest('.dropdown').querySelector('.dropdown-search').value = '';
                    filterFunction(this);
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                });
            }
        }
        dropdown.dataset.searchinitialized = "true";
    });
};

/**
 * Adds close buttons to all date pickers
 */
GeneralUtility.addDatepickerCloseButton = function (pickersToCloseOnClick) {
    document.querySelectorAll('.datepicker-picker .datepicker-header .datepicker-controls').forEach(function (item) {
        if (!item.parentElement.querySelector('.btn-close')) {
            var el = document.createElement('button');
            el.textContent = 'X';
            el.classList.add('btn');
            el.classList.add('btn-close');
            el.classList.add('text-center');
            el.addEventListener('click', function () {
                pickersToCloseOnClick.forEach(function (picker) {
                    picker.hide();
                });
            });
            item.parentElement.insertBefore(el, item);
        }
    });
};


// Caches the result of isTouch()
GeneralUtility.isTouchCache = null;

GeneralUtility.isElementInViewport = function (el, offset) {

    if (!offset) {
        offset = 0;
    }
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + offset &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

/**
 * Appends GET parameter to given url
 *
 * @returns {string}
 */
GeneralUtility.appendUrlParameter = function (url, parameter, value) {
    if (url.indexOf('?') !== -1) {
        url += '&';
    } else {
        url += '?';
    }
    url += parameter + '=' + value;
    return url;
};


/**
 * Checks if the current browser is a touch device.
 *
 * @returns {boolean} True when the device is touchable, otherwise false
 */
GeneralUtility.isTouch = function () {
    if (GeneralUtility.isTouchCache !== null) {
        return GeneralUtility.isTouchCache;
    }

    GeneralUtility.isTouchCache = ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0);
    return GeneralUtility.isTouchCache;
};


/**
 * Checks if the user's browser is Edge.
 *
 * @returns {boolean} True when the users browser is Edge, otherwise false
 */
GeneralUtility.isEdge = function () {
    var userAgent = window.navigator.userAgent;
    return userAgent.indexOf('Edge/') > 0;
};


/**
 * Checks if the user's browser is Internet Explorer.
 *
 * @returns {boolean} True when the users browser is Internet Explorer, otherwise false
 */
GeneralUtility.isInternetExplorer = function () {
    var userAgent = window.navigator.userAgent;

    if (userAgent.indexOf('MSIE ') > 0) {
        return true;
    }

    if (userAgent.indexOf('Trident/') > 0) {
        return true;
    }

    return false;
};


/**
 * Listens to device orientation change.
 *
 * @param {function} callback Called when the orientation changes
 * @returns {void}
 */
GeneralUtility.deviceOrientationChangeListener = function (callback) {
    var orientation = GeneralUtility.getDeviceOrientation();
    var previousOrientation = null;

    window.addEventListener('resize', function () {
        orientation = GeneralUtility.getDeviceOrientation();

        if (orientation !== previousOrientation) {
            callback(orientation);
        }

        previousOrientation = orientation;
    }, {'capture': false, 'passive': true});
};


/**
 * Gets the current device orientation.
 *
 * @returns {string} "portrait" or "landscape"
 */
GeneralUtility.getDeviceOrientation = function () {
    if (window.innerHeight > window.innerWidth) {
        return 'portrait';
    } else {
        return 'landscape';
    }
};


/**
 * Gets the current browser dimensions.
 *
 * @returns {Object} Width and height
 */
GeneralUtility.getBrowserDimensions = function () {
    var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    return {
        'width': width,
        'height': height
    }
};


/**
 * Gets the current browser scroll position.
 *
 * @returns {Object} Top and left
 */
GeneralUtility.getScrollPosition = function () {
    var top = document.documentElement.scrollTop || document.body.scrollTop;
    var left = document.documentElement.scrollLeft || document.body.scrollLeft;

    return {
        'top': top,
        'left': left
    }
};


/**
 * Gets the offset of an element within the browser.
 *
 * @param {Element} element Element to get offset from
 *
 * @returns {Object} Top and left
 */
GeneralUtility.getOffset = function (element) {
    var boundaries = element.getBoundingClientRect();
    var scrollPosition = GeneralUtility.getScrollPosition();
    var top = boundaries.top + scrollPosition.top;
    var left = boundaries.left + scrollPosition.left;

    return {
        'top': top,
        'left': left
    }
};

/**
 * Checks if given JavaScript oject is empty
 *
 * @param {Object} obj Object to test
 *
 * @returns {boolean} Empty or not
 */
GeneralUtility.isEmpty = function (obj) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }

    return true;
};
